module.exports = " <g class=axis :class=classes :transform=transform :style=style></g> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Axis.vue
// module id = 726
// module chunks = 2